import { useEffect, useState } from "react";
import { ResponsiveContainer, ComposedChart, Area, Bar, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from "recharts";
import { TrendingUp, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const NAMES = { active: "Aktive Mitglieder", logins: "Login-Bonus abgeholt", new: "Neue Mitglieder" };
const day = (d) => new Date(`${d}T12:00:00`).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" });

export function ActivityChart() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/activity/history").then(({ data }) => setD(data)).catch(() => setD([])); }, []);
  const avg = d?.length ? Math.round(d.reduce((a, x) => a + x.active, 0) / d.length) : 0;
  const peak = d?.length ? d.reduce((m, x) => (x.active > m.active ? x : m), d[0]) : null;
  return (
    <div className="bg-white rounded-3xl border border-pink-100 p-4 sm:p-5 space-y-3" data-testid="activity-chart">
      <div className="flex flex-wrap items-end justify-between gap-2">
        <p className="font-bold flex items-center gap-2"><TrendingUp className="w-5 h-5 text-rose-500" /> Aktive Mitglieder pro Tag · letzte 30 Tage</p>
        {peak && <p className="text-xs text-slate-500" data-testid="activity-chart-summary">Ø <b className="text-slate-700">{avg}</b> pro Tag · Rekord <b className="text-slate-700">{peak.active}</b> am {day(peak.day)}</p>}
      </div>
      {!d ? <div className="h-64 flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-rose-500" /></div> : (
        <div className="h-64">
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={d} margin={{ top: 8, right: 8, left: -18, bottom: 0 }}>
              <defs><linearGradient id="actFill" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#f43f5e" stopOpacity={0.35} /><stop offset="100%" stopColor="#f43f5e" stopOpacity={0.02} /></linearGradient></defs>
              <CartesianGrid stroke="#fde2ea" vertical={false} />
              <XAxis dataKey="day" tickFormatter={day} tick={{ fontSize: 11, fill: "#94a3b8" }} interval="preserveStartEnd" minTickGap={18} axisLine={false} tickLine={false} />
              <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "#94a3b8" }} axisLine={false} tickLine={false} />
              <Tooltip labelFormatter={(l) => new Date(`${l}T12:00:00`).toLocaleDateString("de-DE", { weekday: "short", day: "2-digit", month: "2-digit" })} formatter={(v, k) => [v, NAMES[k]]}
                contentStyle={{ borderRadius: 16, border: "1px solid #fbcfe8", fontSize: 12 }} />
              <Legend formatter={(k) => NAMES[k]} wrapperStyle={{ fontSize: 12 }} />
              <Bar dataKey="new" fill="#e879f9" radius={[6, 6, 0, 0]} barSize={10} />
              <Area type="monotone" dataKey="active" stroke="#f43f5e" strokeWidth={2.5} fill="url(#actFill)" />
              <Line type="monotone" dataKey="logins" stroke="#f59e0b" strokeWidth={2} dot={false} />
            </ComposedChart>
          </ResponsiveContainer>
        </div>
      )}
      <p className="text-[11px] text-slate-400">Aktiv = hat an dem Tag die App genutzt oder Punkte gesammelt.</p>
    </div>
  );
}
